import { lazyModulePage } from '@/soluqr/tiers/lazyModulePage';

/** SoluGo — páginas del módulo logístico (API en lib/solugo). */
export const solugoRouteElements = [
  {
    segment: 'delivery',
    element: lazyModulePage('solugo', () => import('@/soluqr/modules/solugo/screens/DeliveryPage')),
  },
  {
    segment: 'solugo',
    element: lazyModulePage(
      'solugo',
      () => import('@/soluqr/modules/solugo/screens/SoluGoDashboardRedirect'),
    ),
  },
  {
    segment: 'own-delivery',
    element: lazyModulePage(
      'solugo',
      () => import('@/soluqr/modules/solugo/screens/OwnDeliveryDashboardRedirect'),
    ),
  },
  {
    segment: 'solugo/admin',
    element: lazyModulePage('solugo', () => import('@/soluqr/modules/solugo/screens/SoluGoAdminPage')),
  },
];
